import * as React from 'react';
import BareContentEditableDivEditor from './BareContentEditableDivEditor';
import ReactEditor, { ReactEditorProps } from './ReactEditor';
import PreferredEditorToggle from './PreferredEditorToggle';
import { observer } from 'mobx-react';
import { ComposeEditorType } from 'owa-mail-preferred-editor';
import { getActiveEditorType } from 'owa-mail-preferred-editor/lib/getActiveEditorType';
import { CompositeEditorViewState } from '../store/schema/CompositeEditorViewState';
import { isFeatureEnabled } from 'owa-feature-flags';

export interface CompositeEditorProps extends ReactEditorProps {
    viewState: CompositeEditorViewState;
    plainTextPlaceholder: string;
    onPlainTextContentChange: () => void;
    plainTextEditorRefCallback?: (ref: HTMLTextAreaElement) => void;
}

@observer
export default class CompositeEditor extends React.Component<CompositeEditorProps, {}> {
    private roosterEditor = React.createRef<ReactEditor>();
    private bareCEDEditor = React.createRef<BareContentEditableDivEditor>();

    render() {
        const {
            viewState,
            plainTextPlaceholder,
            onFocus,
            onPlainTextContentChange,
            plainTextEditorRefCallback,
            classNames,
        } = this.props;
        const activeEditor = getActiveEditorType(viewState);
        let editor: JSX.Element = null;

        switch (activeEditor) {
            case ComposeEditorType.RoosterHTML:
                editor = <ReactEditor {...this.props} ref={this.roosterEditor} />;
                break;
            case ComposeEditorType.RawContentEditableDivHTML:
                editor = (
                    <BareContentEditableDivEditor
                        className={classNames}
                        viewState={viewState}
                        ref={this.bareCEDEditor}
                    />
                );
                break;
            case ComposeEditorType.Textarea:
                editor = (
                    <div>
                        <textarea
                            ref={plainTextEditorRefCallback}
                            className={classNames}
                            placeholder={plainTextPlaceholder || ''}
                            onFocus={onFocus}
                            onChange={onPlainTextContentChange}
                            value={viewState.content}
                        />
                    </div>
                );
                break;
        }

        return (
            <>
                {isFeatureEnabled('cmp-downgradeRawCED') && (
                    <PreferredEditorToggle
                        viewState={viewState}
                        getEditorContentFromDom={this.getEditorContentFromDom}
                    />
                )}
                {editor}
            </>
        );
    }

    private getEditorContentFromDom = () => {
        const editor = this.roosterEditor.current || this.bareCEDEditor.current;
        return editor ? editor.getContent() : null;
    };
}
